/** 假优惠价格阶段：idle 展示假价格，claimed 从假价格翻滚到真实价格 */
export type TFakeDiscountPhase = 'idle' | 'claimed';

/**
 * 命中假优惠的商品卡才返回阶段，其余卡返回 undefined（正常展示真实价格）。
 * 轮播卡与平铺网格卡共用同一判定。
 */
export function resolveDiscountPhase(
    productId: string,
    discountProductId?: string,
    discountClaimed?: boolean
): TFakeDiscountPhase | undefined {
    if (productId !== discountProductId) {
        return undefined;
    }
    return discountClaimed ? 'claimed' : 'idle';
}
